// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/accounts": [5],
		"/activity": [6],
		"/activity/changes": [7],
		"/admin": [8],
		"/akahu": [9],
		"/assets": [10],
		"/connect": [11],
		"/connect/success": [12],
		"/dashboard": [13],
		"/demo/akahu/approve": [14,[2]],
		"/demo/akahu/authorize": [15,[2]],
		"/demo/akahu/banks": [16,[2]],
		"/demo/akahu/confirm": [17,[2]],
		"/demo/akahu/connection/[id]": [18,[2]],
		"/demo/akahu/consent": [19,[2]],
		"/demo/akahu/hub": [20,[2]],
		"/demo/akahu/otp": [21,[2]],
		"/demo/akahu/redirect": [22,[2]],
		"/goals": [23],
		"/goals/new": [24],
		"/help": [25],
		"/landing": [26],
		"/login": [27],
		"/notifications": [28],
		"/payees": [29],
		"/pricing": [30],
		"/privacy": [31],
		"/queue": [32],
		"/rules": [33],
		"/rules/create": [34],
		"/rules/create/guided": [35],
		"/rules/new": [36],
		"/safety": [37],
		"/settings": [38],
		"/settings/billing": [39],
		"/settings/payees": [40],
		"/settings/payment-consents": [41],
		"/setup-passkey": [42],
		"/subscriptions": [43],
		"/subscriptions/[id]": [44],
		"/terms": [45],
		"/[...catchall]": [4]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);